import React, { useRef } from 'react'

import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Button } from '@material-ui/core'

import {
  focusAlert,
  selectMyAlertsRef,
  updateAlertsHistoryOpen,
  updateAlertTitle,
  updateMainTabValue,
  updateSecondaryTabValue,
} from '../MyAlertsSlice'
import AlertList from './AlertList'
import {
  RutgersTab,
  RutgersTabs,
} from '../../../DashboardComponents/Tabs/RutgersTabs'
import { TabPanel } from '../../../DashboardComponents/TabPanel/TabPanel'
import { useTabTracking } from '../../../../../helpers/useTabTracking'
import { trackWidgetClick } from '../../../../../helpers/trackWidgetClick'
import { MyNotificaionAlertList } from './MyNotificationAlertList'
import CaseIndicator from '../../../DashboardComponents/CaseIndicator/CaseIndicator'

function AlertGUI({ data, classes, dialogHandler }) {
  const { alertTitle, mainTabValue, secondaryTabValue } = useSelector(
    (s) => s.myAlerts,
  )
  console.log('alertTitle ', alertTitle)
  console.log('mainTabValue ', mainTabValue)
  console.log('secondaryTabValue ', secondaryTabValue)
  const {
    personalAlerts,
    emergencyAlerts,
    itAlerts,
    refundAlerts,
    customNotifications,
  } = data.alerts
  const [activeLabel, historyLabel] = data.categories
  const personalLabel = <Typography variant="body1">{activeLabel}</Typography>
  const emergencyLabel = <Typography variant="body1">{historyLabel}</Typography>
  const dispatch = useDispatch()
  const trackTabChange = useTabTracking(dispatch, 'MyAlerts', [
    activeLabel,
    historyLabel,
  ])
  const handleChange = (_event, newValue) => {
    trackTabChange(_event, newValue)
    dispatch(updateSecondaryTabValue(newValue))
  }
  const handleMainTabChange = (_event, newValue) => {
    trackTabChange(_event, newValue)
    dispatch(
      updateAlertTitle(newValue === 0 ? 'Alert Center' : 'Notification Center'),
    )
    dispatch(updateMainTabValue(newValue))
  }

  const [activeList, setActiveList] = React.useState([])
  const [historyList, setHistoryList] = React.useState([])
  const [activeNotificationList, setActiveNotificationList] = React.useState([])
  const [historyNotificationList, setHistoryNotificationList] = React.useState(
    [],
  )
  const handleViewPastHistory = () => {
    trackWidgetClick(dispatch, 'MyAlerts', 'View Past History')
    dispatch(updateAlertsHistoryOpen())
  }
  React.useEffect(() => {
    // Removed ...refundAlerts for now 3/29/24
    const combinedList = [
      ...(Array.isArray(personalAlerts) ? personalAlerts : []),
      ...(Array.isArray(itAlerts) ? itAlerts : []),
      ...(Array.isArray(refundAlerts) ? refundAlerts : []),
      ...(Array.isArray(customNotifications) ? customNotifications : []),
    ]

    let newerActiveList = combinedList.filter(
      (alert) => alert.acknowledgedTS === '',
    )
    newerActiveList = [...(emergencyAlerts || []), ...newerActiveList]
    setActiveList(newerActiveList?.filter((item) => item))
    const newHistoryList = combinedList?.filter(
      (alert) => alert.acknowledgedTS !== '',
    )
    setHistoryList(newHistoryList?.filter((item) => item))
    // active notification list and history
    setActiveNotificationList(
      data.notificationAlerts.filter(
        (nAlert) => nAlert?.acknowledgements?.length === 0,
      ),
    )
    setHistoryNotificationList(
      data.notificationAlerts.filter(
        (nAlert) => nAlert?.acknowledgements?.length > 0,
      ),
    )
  }, [data])

  const alertsRef = useRef(null)
  const focusAlertsNotifier = useSelector(selectMyAlertsRef)
  React.useEffect(() => {
    if (focusAlertsNotifier) {
      alertsRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center',
      })
      dispatch(focusAlert())
    }
  }, [focusAlertsNotifier])

  return (
    <Grid
      container
      direction="column"
      wrap="nowrap"
      className={classes.retainer}
      ref={alertsRef}
    >
      <Grid item className={classes.modalTab}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
          }}
        >
          <RutgersTabs
            value={mainTabValue}
            onChange={handleMainTabChange}
            style={{ minWidth: '100%' }}
          >
            <RutgersTab
              label={
                <Box display="flex" style={{ alignItems: 'center' }}>
                  <Typography className={classes.tabTextLabel}>
                    Alerts
                  </Typography>
                  {activeList && activeList?.length > 0 && (
                    <CaseIndicator value={activeList?.length} />
                  )}
                </Box>
              }
              onFocus={() => {}}
              tabIndex={0}
              style={{ minWidth: '50%' }}
            />
            <RutgersTab
              label={
                <Box display="flex" style={{ alignItems: 'center' }}>
                  <Typography className={classes.tabTextLabel}>
                    Notifications
                  </Typography>
                  {activeNotificationList &&
                    activeNotificationList?.length > 0 && (
                      <CaseIndicator
                        value={activeNotificationList?.length}
                        caseIndicatorStyle={classes.notifIndicatorContainer}
                      />
                    )}
                </Box>
              }
              onFocus={() => {}}
              tabIndex={0}
              style={{ minWidth: '50%' }}
            />
          </RutgersTabs>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
          }}
        >
          <RutgersTabs
            value={secondaryTabValue}
            onChange={handleChange}
            style={{ minWidth: '100%' }}
          >
            <RutgersTab
              label={personalLabel}
              onFocus={() => {}}
              tabIndex={0}
              style={{ minWidth: '50%' }}
            />
            <RutgersTab
              label={emergencyLabel}
              onFocus={() => {}}
              tabIndex={0}
              style={{ minWidth: '50%' }}
            />
          </RutgersTabs>
        </Box>
      </Grid>
      <div
        className={
          secondaryTabValue === 2
            ? classes.alertsListContainer
            : classes.alertsListContainerHistory
        }
        style={{ height: '100%' }}
      >
        <TabPanel value={secondaryTabValue} index={0}>
          {alertTitle === 'Alert Center' ? (
            <AlertList
              alertList={activeList}
              classes={classes}
              dialogHandler={dialogHandler}
            />
          ) : (
            <MyNotificaionAlertList
              alertList={activeNotificationList}
              classes={classes}
              dialogHandler={dialogHandler}
            />
          )}
        </TabPanel>
        <TabPanel
          value={secondaryTabValue}
          index={1}
          style={{ height: '100%' }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
              justifyContent: 'space-between',
            }}
          >
            {alertTitle === 'Alert Center' ? (
              <AlertList
                alertList={historyList}
                classes={classes}
                dialogHandler={dialogHandler}
                alertHistory
                dispatch={dispatch}
              />
            ) : (
              <MyNotificaionAlertList
                alertList={historyNotificationList}
                classes={classes}
                dialogHandler={dialogHandler}
              />
            )}
            <Box sx={{ padding: '11px' }}>
              <Button
                className={classes.pastHistoryButton}
                aria-label="View Past History"
                variant="outlined"
                onClick={handleViewPastHistory}
              >
                View Past History
              </Button>
            </Box>
          </Box>
        </TabPanel>
      </div>
    </Grid>
  )
}

export default AlertGUI
